import { createFileRoute } from "@tanstack/react-router";
import { BestillingPage } from "@/features/bestillinger/BestillingPage";

export const Route = createFileRoute("/_app/_subheader/bestillinger")({
  component: BestillingPage,
  head: () => ({
    meta: [
      {
        title: "Bestillinger | Selskapsportal for fjernvarme",
      },
    ],
  }),
});
